import { Link } from "react-router-dom";
import { Calendar, MapPin } from "lucide-react";
import { formatShortDate, formatPrice } from "@/lib/format";
import VerifiedBadge from "@/components/VerifiedBadge";

export default function EventCard({ event, testIdPrefix = "event-card" }) {
  return (
    <Link
      to={`/event/${event.id}`}
      className="z-event-card"
      data-testid={`${testIdPrefix}-${event.id}`}
    >
      {event.image_url ? (
        <img src={event.image_url} alt={event.title} className="z-event-card-img" loading="lazy" />
      ) : (
        <div className="z-event-card-img" style={{ background: "linear-gradient(135deg,#01696F,#20808D)" }} />
      )}
      <div className="z-event-card-body">
        <h3 className="z-event-card-title" style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{event.title}</span>
          <VerifiedBadge verified={event.organizer_verified} variant="icon" size={15} testId={`event-card-verified-${event.id}`} />
        </h3>
        <p className="z-event-card-meta">
          <Calendar size={13} style={{ display: "inline", verticalAlign: "middle", marginRight: 4 }} />
          {formatShortDate(event.starts_at)}
        </p>
        <p className="z-event-card-meta">
          <MapPin size={13} style={{ display: "inline", verticalAlign: "middle", marginRight: 4 }} />
          {event.location || "Lieu communiqué"}
        </p>
        <span className="z-event-card-price">{formatPrice(event.price, event.currency)}</span>
      </div>
    </Link>
  );
}
